/* Panier LATÉRAL « façon Loban » (lot 2 — docs/superpowers/specs/2026-10-03-moola-facon-loban.md, §§ 4.4 et 10).
   - L'icône panier de l'en-tête ouvre le tiroir (sans JavaScript, son lien mène à /cart : repli intact). Sur la page
     /cart elle-même, le lien n'est pas intercepté (le panier est déjà affiché en grand).
   - Ouverture : window.MoolaTiroir (dialogue modal, focus piégé, Échap / croix / voile, verrou du défilement) ; contenu
     rafraîchi en arrière-plan (GET ?sections=moola-panier-tiroir) au cas où le panier aurait changé ailleurs.
   - Quantités : module commun MoolaQuantites (clé de ligne, file, readOnly, « Paiement » différé) ; chaque geste envoie
     UNE requête /cart/change.js qui renvoie le HTML de la section, remplacé tel quel (Section Rendering) ; le focus est
     rendu au même contrôle dans le nouveau contenu.
   - window.MoolaPanier.afficher(html, { ouvrir, declencheur }) : appelé par la fiche après un ajout (/cart/add.js avec
     sections) — l'ouverture du tiroir confirme l'ajout, comme chez Loban. */
(function () {
  var racine = document.querySelector('[data-moola-panier-tiroir]');
  var voile = document.querySelector('[data-moola-panier-voile]');
  if (!racine || !window.MoolaTiroir || !window.MoolaQuantites) { return; }
  var SECTION = 'moola-panier-tiroir';
  var DUREE = 420;   // dévoilement de 400 ms : `hidden` n'est reposé qu'après l'animation de fermeture
  var form = racine.querySelector('[data-moola-panier-corps]');
  var compte = racine.querySelector('[data-moola-panier-compte]');
  var focusVoulu = null;

  // Tiroir et voile directement sous <body> : aucun ancêtre transformé ou rogné.
  [voile, racine].forEach(function (el) { if (el && el.parentElement !== document.body) { document.body.appendChild(el); } });

  function remplacer(html, siChange) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var neuf = doc.querySelector('[data-moola-panier-corps]');
    if (!neuf) { return false; }
    // Rafraîchissement d'arrière-plan : contenu inchangé → rien n'est touché (ni le focus, ni les nœuds en cours d'usage).
    if (siChange && neuf.innerHTML === form.innerHTML) { return true; }
    var actif = document.activeElement && racine.contains(document.activeElement) ? document.activeElement.getAttribute('data-focus') : null;
    form.innerHTML = neuf.innerHTML;
    var n = neuf.getAttribute('data-item-count');
    form.setAttribute('data-item-count', n);
    var c = doc.querySelector('[data-moola-panier-compte]');
    if (c && compte) { compte.textContent = c.textContent; compte.setAttribute('aria-label', c.getAttribute('aria-label')); }
    document.dispatchEvent(new CustomEvent('moola:panier', { detail: { item_count: Number(n) || 0 } }));
    // Focus rendu au même contrôle (même ligne, même rôle) ; si la ligne a disparu, au premier élément utile.
    var cible = (focusVoulu || actif) && form.querySelector('[data-focus="' + (focusVoulu || actif) + '"]');
    focusVoulu = null;
    if (window.MoolaTiroir.ouvert(racine) && (actif || cible)) {
      (cible || form.querySelector('a[href], button, input') || racine.querySelector('[data-tiroir-fermer]')).focus({ preventScroll: true });
    }
    return true;
  }

  var quantites = window.MoolaQuantites(form, {
    selecteur: '[data-qte]',
    sections: [SECTION],
    fin: function (json) {
      if (json && json.sections && json.sections[SECTION] && remplacer(json.sections[SECTION])) { return; }
      rafraichir();
    }
  });

  function rafraichir() {
    fetch('/?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j[SECTION] && !quantites.occupe()) { remplacer(j[SECTION], true); } })
      .catch(function () { /* contenu rendu au chargement conservé */ });
  }

  // [−] / [+] et « Retirer » : une requête par geste, ligne marquée occupée (chargeur sur la vignette).
  form.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qte-pas], [data-qte-retirer]');
    if (!b || !form.contains(b)) { return; }
    e.preventDefault();
    var cle = b.getAttribute('data-cle');
    var champ = form.querySelector('[data-qte][data-cle="' + cle + '"]');
    var ligne = b.closest('[data-cle]');
    if (ligne) { ligne.setAttribute('aria-busy', 'true'); }
    var q = b.hasAttribute('data-qte-retirer') ? 0 : (Number(champ && champ.value) || 0) + Number(b.getAttribute('data-qte-pas'));
    focusVoulu = b.getAttribute('data-focus');
    quantites.demander(cle, q);
  });

  function ouvrir(declencheur) {
    window.MoolaTiroir.ouvrir(racine, { declencheur: declencheur, voile: voile, duree: DUREE, focus: '[data-tiroir-fermer]' });
  }

  var icone = document.querySelector('[data-moola-panier]');
  var surPagePanier = !!document.getElementById('moola-panier');
  if (icone && !surPagePanier) {
    icone.setAttribute('aria-controls', racine.id);
    icone.setAttribute('aria-haspopup', 'dialog');
    icone.setAttribute('aria-expanded', 'false');
    icone.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) { return; }   // ouverture dans un nouvel onglet : lien normal
      e.preventDefault();
      ouvrir(icone);
      rafraichir();
    });
  }

  window.MoolaPanier = {
    ouvrir: ouvrir,
    afficher: function (html, o) {
      o = o || {};
      var ok = remplacer(html);
      if (ok && o.ouvrir && !surPagePanier) { ouvrir(o.declencheur || document.activeElement); }
      return ok;
    }
  };
})();
